import * as fromDatatype from '../datatype-library/index';
import * as fromDataype from "../datatype-library";

export interface app_generic_resources_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  instance_guid: fromDatatype.GuidDataFieldInterface;
  instance_code: fromDatatype.VarcharDatatypeInterface;
  instance_category: fromDatatype.VarcharDatatypeInterface;
  resource_type: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDataype.VarcharDatatypeInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  connection_json: fromDatatype.JsonDatatypeInterface;
  specifications_json: fromDatatype.JsonDatatypeInterface;
  resource_version: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class app_generic_resources_hdr_RowClass implements app_generic_resources_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  instance_guid: fromDatatype.GuidDataFieldInterface;
  instance_code: fromDatatype.VarcharDatatypeInterface;
  instance_category: fromDatatype.VarcharDatatypeInterface;
  resource_type: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDataype.VarcharDatatypeInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  connection_json: fromDatatype.JsonDatatypeInterface;
  specifications_json: fromDatatype.JsonDatatypeInterface;
  resource_version: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}


